import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=cbd5d9aa&scoped=true&"
import script from "./bankInfo.vue?vue&type=script&lang=js&"
export * from "./bankInfo.vue?vue&type=script&lang=js&"
import style0 from "./bankInfo.vue?vue&type=style&index=0&id=cbd5d9aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd5d9aa",
  null
  
)

export default component.exports